const networkLines = () => {
  const networkFirst = document.querySelector('[data-network-first]');
  const networkSecond = document.querySelector('[data-network-second]');
  const networkThird = document.querySelector('[data-network-third]');
  const networkCenter = document.querySelector('[data-network-center]');

  if (networkFirst && networkSecond && networkThird && networkCenter) {
    /* mobile stuff  */

    networkFirst.style.setProperty(
      '--network-offset-top',
      `${networkCenter.offsetTop -
        networkFirst.offsetTop -
        networkFirst.offsetHeight +
        networkCenter.offsetHeight / 2}px`,
    );
    networkFirst.style.setProperty(
      '--network-offset-left-bottom',
      `${networkCenter.offsetLeft - networkFirst.offsetLeft}px`,
    );

    const networkSecondPill = networkSecond.querySelector('.c-pill');

    networkSecond.style.setProperty(
      '--network-offset-top',
      `${networkCenter.offsetTop -
        networkSecond.offsetTop -
        networkSecond.offsetHeight +
        networkCenter.offsetHeight / 2}px`,
    );
    networkSecond.style.setProperty(
      '--network-offset-left-top',
      `${networkSecond.offsetWidth - networkSecondPill.offsetWidth}px`,
    );

    networkSecond.style.setProperty(
      '--network-offset-left-bottom',
      `${networkCenter.offsetLeft - networkSecond.offsetLeft}px`,
    );

    const networkThirdPill = networkThird.querySelector('.c-pill');

    networkThird.style.setProperty(
      '--network-offset-top',
      `${networkCenter.offsetTop -
        networkThird.offsetTop -
        networkThird.offsetHeight +
        networkCenter.offsetHeight / 2}px`,
    );
    networkThird.style.setProperty(
      '--network-offset-left-top',
      `${networkThird.offsetWidth - networkThirdPill.offsetWidth}px`,
    );

    networkThird.style.setProperty(
      '--network-offset-left-bottom',
      `${networkCenter.offsetLeft - networkThird.offsetLeft}px`,
    );

    /* desktop */

    networkFirst.style.setProperty(
      '--network-offset-desktop-top',
      `${networkCenter.offsetLeft -
        networkFirst.offsetLeft -
        networkFirst.offsetWidth +
        networkCenter.offsetWidth / 2}px`,
    );
    networkFirst.style.setProperty(
      '--network-offset-desktop-left-bottom',
      `${networkCenter.offsetTop - networkFirst.offsetTop}px`,
    );

    networkSecond.style.setProperty(
      '--network-offset-desktop-top',
      `${networkCenter.offsetLeft -
        networkSecond.offsetLeft -
        networkSecond.offsetWidth / 2 +
        networkCenter.offsetWidth / 2}px`,
    );

    networkSecond.style.setProperty(
      '--network-offset-desktop-left-bottom',
      `${(networkSecond.offsetTop -
        networkCenter.offsetTop -
        networkCenter.offsetHeight) /
        2}px`,
    );

    networkThird.style.setProperty(
      '--network-offset-desktop-top',
      `${Math.abs(
        networkThird.offsetLeft -
          networkCenter.offsetLeft -
          networkCenter.offsetWidth / 2,
      )}px`,
    );
    networkThird.style.setProperty(
      '--network-offset-desktop-left-bottom',
      `${networkCenter.offsetTop -
        networkThird.offsetTop -
        networkThird.offsetHeight / 2}px`,
    );
  }
};

document.addEventListener('DOMContentLoaded', () => {
  networkLines();
});

window.addEventListener('resize', () => {
  networkLines();
});



// WEBPACK FOOTER //
// ./src/scripts/modules/network.js